import { Component, OnInit } from '@angular/core';
import { Guid } from 'guid-typescript';
import { BannerService, BannerServiceStatus } from 'src/app/services/banner.service';

@Component({
  selector: 'app-banner-test',
  templateUrl: './banner-test.component.html',
  styleUrls: ['./banner-test.component.scss']
})
export class BannerTestComponent implements OnInit {

  constructor(private bannerService: BannerService) { }

  Ids: Guid[] = [];

  onClick(index: Guid) {
    this.bannerService.RemoveMessage(index);
  }

  ngOnInit(): void {
    let i = 0;
    this.Ids[i]   = this.bannerService.AddMessage("This is an <a>info</a> message", BannerServiceStatus.info);
    this.Ids[++i] = this.bannerService.AddMessage("This is a <a>success</a> message", BannerServiceStatus.success);
    this.Ids[++i] = this.bannerService.AddMessage("This is an <a>error</a> message", BannerServiceStatus.error);
    this.Ids[++i] = this.bannerService.AddMessage("This is a <a>warning</a> message", BannerServiceStatus.warning);
  }
}
